import React from 'react';
import styled from 'styled-components';

const FormattedResultsContainer = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 1.05rem;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.9);
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  
  .content-block {
    background: linear-gradient(145deg, rgba(26, 11, 51, 0.6), rgba(31, 15, 60, 0.8));
    border-radius: 12px;
    padding: 20px 25px;
    margin: 25px 0;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    position: relative;
    border-left: 2px solid var(--primary-color);
  }
  
  .main-title {
    color: var(--primary-color);
    font-family: 'Bubblegum Sans', 'Poppins', sans-serif;
    font-size: 1.8rem;
    font-weight: 600;
    margin: 35px 0 20px;
    text-align: center;
    text-shadow: 0 2px 8px rgba(255, 64, 192, 0.3);
    position: relative;
    padding-bottom: 15px;
    
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      height: 3px;
      background: linear-gradient(to right, transparent, var(--primary-color), transparent);
      border-radius: 3px;
    }
  }
  
  .section-title {
    color: var(--secondary-color);
    font-family: 'Bubblegum Sans', 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 600;
    margin: 35px 0 20px;
    border-bottom: 1px solid rgba(255, 208, 0, 0.3);
    padding-bottom: 10px;
    text-shadow: 0 2px 8px rgba(255, 208, 0, 0.3);
    position: relative;
    text-align: center;
    
    &::before {
      content: "✦";
      position: absolute;
      left: 0;
      bottom: 8px;
      font-size: 1.2rem;
      color: var(--secondary-color);
      opacity: 0.6;
    }
    
    &::after {
      content: "✦";
      position: absolute;
      right: 0;
      bottom: 8px;
      font-size: 1.2rem;
      color: var(--secondary-color);
      opacity: 0.6;
    }
  }
  
  .subsection-title {
    color: var(--primary-color);
    font-size: 1.3rem;
    font-weight: 500;
    margin: 25px 0 15px;
    position: relative;
    padding-left: 12px;
    
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      bottom: 5px;
      width: 4px;
      background: linear-gradient(to bottom, var(--primary-color), var(--accent-color));
      border-radius: 3px;
      box-shadow: 0 0 8px rgba(255, 64, 192, 0.4);
    }
  }
  
  .highlight {
    color: var(--secondary-color);
    font-weight: 600;
    position: relative;
    padding: 0 3px;
    
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 5px;
      background-color: rgba(255, 208, 0, 0.15);
      z-index: -1;
      border-radius: 2px;
    }
  }
  
  .profile-name {
    color: var(--accent-color);
    font-weight: 600;
    position: relative;
    padding: 0 3px;
    
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 5px;
      background-color: rgba(0, 213, 255, 0.15);
      z-index: -1;
      border-radius: 2px;
    }
  }
  
  p {
    margin-bottom: 20px;
    text-align: justify;
    line-height: 1.8;
  }
  
  ul {
    margin-left: 0;
    margin-bottom: 30px;
    list-style-type: none;
    padding-left: 0;
  }
  
  li {
    margin-bottom: 22px;
    padding-left: 28px;
    text-align: justify;
    position: relative;
    
    &::before {
      content: "💘";
      position: absolute;
      left: 0;
      top: 2px;
      font-size: 1rem;
    }
    
    &:nth-child(2n)::before {
      content: "💫";
    }
    
    &:nth-child(3n)::before {
      content: "🌟";
    }
    
    &:nth-child(4n)::before {
      content: "💖";
    }
    
    &:nth-child(5n)::before {
      content: "✨";
    }
  }
  
  .intro-text {
    font-style: italic;
    text-align: center;
    margin-bottom: 35px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.1rem;
    padding: 25px;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(255, 64, 192, 0.2), rgba(255, 208, 0, 0.15));
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);
    position: relative;
    overflow: hidden;
    
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(to right, var(--primary-color), var(--secondary-color));
      border-radius: 3px 3px 0 0;
    }
    
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(to right, var(--secondary-color), var(--primary-color));
      border-radius: 0 0 3px 3px;
    }
  }
  
  .trait-container {
    margin-bottom: 35px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 12px;
    padding-bottom: 15px;
    border-left: 3px solid rgba(255, 64, 192, 0.3);
    background-color: rgba(255, 64, 192, 0.05);
    border-radius: 0 8px 8px 0;
    transition: all 0.3s ease;
    
    &:hover {
      background-color: rgba(255, 64, 192, 0.08);
      transform: translateX(3px);
    }
  }
  
  .trait-name {
    color: var(--primary-color);
    font-weight: 600;
    font-size: 1.2rem;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    
    &::before {
      content: attr(data-emoji);
      margin-right: 10px;
      font-size: 1.4rem;
    }
  }
  
  .trait-description {
    color: rgba(255, 255, 255, 0.85);
  }
  
  /* Aggiunto: divisore decorativo tra sezioni principali */
  .section-divider {
    margin: 40px auto;
    width: 70%;
    height: 2px;
    background: linear-gradient(to right, transparent, var(--secondary-color), transparent);
    opacity: 0.6;
    border-radius: 2px;
    position: relative;
    
    &::before, &::after {
      content: "•";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: var(--secondary-color);
      font-size: 1.2rem;
      opacity: 0.7;
    }
    
    &::before {
      left: 30%;
    }
    
    &::after {
      right: 30%;
    }
  }
  
  .text-card {
    background: linear-gradient(145deg, rgba(40, 15, 70, 0.6), rgba(60, 20, 100, 0.5));
    border-radius: 12px;
    padding: 20px;
    margin: 15px 0;
    border-left: 2px solid var(--primary-color);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }
`;

// Funzione per formattare il testo dell'analisi
export const formatAnalysisText = (text) => {
  if (!text) return null;
  
  // Log per debug della lunghezza del testo ricevuto
  console.log("Formatting analysis text of length:", text.length);
  
  // Split the text into lines
  const lines = text.split('\n').filter(line => line.trim() !== '');
  
  // Log per debug del numero di linee
  console.log("Number of lines to format:", lines.length);
  
  // Initialize the formatted result
  const formattedResult = [];
  let currentList = null;
  let currentListItems = [];
  let sectionCount = 0;
  let currentContentBlock = null;
  
  // Emojis for personality traits
  const personalityEmojis = ["😎", "✨", "🔥", "💫", "🌟", "💖", "🚀", "🌈", "💯", "🧠", "🤝", "🎯", "👀", "⭐"];
  let emojiIndex = 0;
  
  // Check if text contains personality traits section
  const hasPersonalityTraits = text.includes("Personality Traits") || 
                              text.includes("Perceived Personality") || 
                              text.includes("Personality Analysis");
  
  // Process each line
  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    
    // Salta la prima riga se è la classica intro
    if (index === 0 && trimmedLine.includes("Here is an analysis of the Instagram profile")) {
      return;
    }
    
    // Main titles (## headings)
    if (trimmedLine.startsWith('## ')) {
      // Close any existing content block before starting a new section
      if (currentContentBlock) {
        formattedResult.push(React.createElement('div', { key: `block-end-${currentContentBlock}` }));
        currentContentBlock = null;
      }
      
      if (currentList) {
        formattedResult.push(<ul key={`list-${index}`}>{currentListItems}</ul>);
        currentList = null;
        currentListItems = [];
      }
      
      sectionCount++;
      const titleText = trimmedLine.replace(/^## /, '').replace(/:$/, '');
      
      // Add decorative divider every section except for the first one
      if (sectionCount > 1) {
        formattedResult.push(
          <div 
            key={`divider-${index}`} 
            className="section-divider"
          />
        );
      }
      
      formattedResult.push(<h2 key={index} className="section-title">{titleText}</h2>);
      
      // Start a new content block after each main section title
      currentContentBlock = index;
      formattedResult.push(<div key={`block-start-${index}`} className="content-block" />);
    } 
    // Subtitles (### headings)
    else if (trimmedLine.startsWith('### ')) {
      if (currentList) {
        formattedResult.push(<ul key={`list-${index}`}>{currentListItems}</ul>);
        currentList = null;
        currentListItems = [];
      }
      
      const titleText = trimmedLine.replace(/^### /, '').replace(/:$/, '');
      formattedResult.push(<h3 key={index} className="subsection-title">{titleText}</h3>);
    }
    // Old format main titles (usually at beginning of sections)
    else if (trimmedLine.startsWith('**') && trimmedLine.endsWith('**') && 
        !trimmedLine.startsWith('* **') && !trimmedLine.includes(':**')) {
      if (currentList) {
        formattedResult.push(<ul key={`list-${index}`}>{currentListItems}</ul>);
        currentList = null;
        currentListItems = [];
      }
      
      const titleText = trimmedLine.replace(/\*\*/g, '');
      formattedResult.push(<h2 key={index} className="main-title">{titleText}</h2>);
    } 
    // Old format section titles (usually numbered like "1. **Title:**")
    else if (/^\d+\.\s+\*\*.*\*\*$/.test(trimmedLine)) {
      if (currentList) {
        formattedResult.push(<ul key={`list-${index}`}>{currentListItems}</ul>);
        currentList = null;
        currentListItems = [];
      }
      
      const titleText = trimmedLine.replace(/^\d+\.\s+\*\*|\*\*$/g, '');
      formattedResult.push(<h3 key={index} className="section-title">{titleText}</h3>);
    }
    // Special handling for personality traits
    else if (hasPersonalityTraits && trimmedLine.match(/^\*\*([^:]+):\*\*/)) {
      if (currentList) {
        formattedResult.push(<ul key={`list-${index}`}>{currentListItems}</ul>);
        currentList = null;
        currentListItems = [];
      }
      
      // Extract trait name and description
      const match = trimmedLine.match(/^\*\*([^:]+):\*\*(.*)/);
      if (match) {
        const traitName = match[1];
        const traitDescription = formatHighlights(match[2]);
        
        // Get an emoji for this trait and cycle through the list
        const emoji = personalityEmojis[emojiIndex % personalityEmojis.length];
        emojiIndex++;
        
        formattedResult.push(
          <div key={`trait-${index}`} className="trait-container">
            <div className="trait-name" data-emoji={emoji}>{traitName}</div>
            <div className="trait-description">{traitDescription}</div>
          </div>
        );
      }
    }
    // List items starting with "*"
    else if (trimmedLine.startsWith('* ')) {
      if (!currentList) {
        currentList = true;
        currentListItems = [];
      }
      
      // Format the list item content with highlighted parts
      const itemText = trimmedLine.substring(2);
      const formattedItem = formatHighlights(itemText);
      
      currentListItems.push(<li key={`item-${index}`}>{formattedItem}</li>);
    }
    // List items starting with "-"
    else if (trimmedLine.startsWith('- ')) {
      if (!currentList) {
        currentList = true;
        currentListItems = [];
      }
      
      // Format the list item content with highlighted parts
      const itemText = trimmedLine.substring(2);
      const formattedItem = formatHighlights(itemText);
      
      currentListItems.push(<li key={`item-${index}`}>{formattedItem}</li>);
    }
    // Regular paragraphs
    else {
      if (currentList) {
        formattedResult.push(<ul key={`list-${index}`}>{currentListItems}</ul>);
        currentList = null;
        currentListItems = [];
      }
      
      // Check if this is an intro paragraph (usually the first paragraph after a title)
      const isIntro = (index < 5 || (index > 0 && lines[index-1].startsWith('##'))) && 
                      !trimmedLine.includes('**') && 
                      !trimmedLine.startsWith('#') &&
                      trimmedLine.length > 50;
      
      const formattedParagraph = formatProfileAndHighlights(trimmedLine);
      
      // If it's the first paragraph of a section, make it a card
      if (isIntro) {
        formattedResult.push(
          <p key={index} className="intro-text">
            {formattedParagraph}
          </p>
        );
      } else {
        formattedResult.push(
          <p key={index}>
            {formattedParagraph}
          </p>
        );
      }
    }
  });
  
  // Add any remaining list items
  if (currentList) {
    formattedResult.push(<ul key="list-final">{currentListItems}</ul>);
  }
  
  // Close any remaining content block at the end
  if (currentContentBlock) {
    formattedResult.push(React.createElement('div', { key: `block-end-${currentContentBlock}` }));
  }
  
  return formattedResult;
};

// Controlla se il testo è un nome/username
const isProfileName = (text) => {
  // Cerchiamo pattern come "named [nome]" o "known as [username]"
  return text.match(/named\s+[\w\s]+(Nanta|nanta)/i) || 
         text.match(/known\s+as\s+["']?\@?[\w\._]+(gizzde|Supichaya|supichaya)/i) || 
         text.match(/\@?[\w\._]+(gizzde|Supichaya|supichaya)/i);
};

// Funzione per formattare sia evidenziazioni che nomi di profilo
export const formatProfileAndHighlights = (text) => {
  if (!text.includes('**')) return text;
  
  const parts = [];
  let remainingText = text;
  let lastIndex = 0;
  let boldStart = remainingText.indexOf('**');
  let highlightCount = 0; // Contatore per limitare le evidenziazioni
  const maxHighlights = 2; // Massimo numero di evidenziazioni per paragrafo
  
  while (boldStart !== -1) {
    // Add normal text before the bold part
    if (boldStart > 0) {
      // Cerca nomi di profilo nel testo normale
      const beforeText = remainingText.substring(0, boldStart);
      
      // Check for profile names in the text
      if (isProfileName(beforeText)) {
        // Cerca pattern specifici per i nomi
        const matches = beforeText.match(/(named\s+)([\w\s]+)|(known\s+as\s+)(["']?\@?[\w\._]+)/i);
        
        if (matches) {
          const startIdx = matches.index;
          const matchLength = matches[0].length;
          const beforeMatch = beforeText.substring(0, startIdx);
          const match = beforeText.substring(startIdx, startIdx + matchLength);
          const afterMatch = beforeText.substring(startIdx + matchLength);
          
          parts.push(beforeMatch);
          parts.push(<span key={`name-${lastIndex}`} className="profile-name">{match}</span>);
          parts.push(afterMatch);
        } else {
          parts.push(beforeText);
        }
      } else {
        parts.push(beforeText);
      }
    }
    
    // Find the end of the bold part
    const boldEnd = remainingText.indexOf('**', boldStart + 2);
    if (boldEnd === -1) break; // Unmatched ** found
    
    // Extract and add the bold part
    const boldText = remainingText.substring(boldStart + 2, boldEnd);
    
    // Special handling for "keyword:" format
    if (boldText.endsWith(':')) {
      parts.push(<span key={`key-${lastIndex}`} className="subsection-title">{boldText}</span>);
    } else if (isProfileName(boldText)) {
      // Evidenzia nomi di profilo con uno stile diverso
      parts.push(<span key={`key-${lastIndex}`} className="profile-name">{boldText}</span>);
    } else {
      // Applica l'evidenziazione solo se non abbiamo superato il limite
      if (highlightCount < maxHighlights) {
        parts.push(<span key={`key-${lastIndex}`} className="highlight">{boldText}</span>);
        highlightCount++;
      } else {
        // Altrimenti, manteniamo il testo senza evidenziarlo
        parts.push(boldText);
      }
    }
    
    // Continue with the rest of the text
    remainingText = remainingText.substring(boldEnd + 2);
    lastIndex++;
    boldStart = remainingText.indexOf('**');
  }
  
  // Add any remaining text
  if (remainingText) {
    // Cerca nomi di profilo nel testo rimanente
    if (isProfileName(remainingText)) {
      // Cerca pattern specifici per i nomi
      const matches = remainingText.match(/(named\s+)([\w\s]+)|(known\s+as\s+)(["']?\@?[\w\._]+)/i);
      
      if (matches) {
        const startIdx = matches.index;
        const matchLength = matches[0].length;
        const beforeMatch = remainingText.substring(0, startIdx);
        const match = remainingText.substring(startIdx, startIdx + matchLength);
        const afterMatch = remainingText.substring(startIdx + matchLength);
        
        parts.push(beforeMatch);
        parts.push(<span key={`name-${lastIndex}`} className="profile-name">{match}</span>);
        parts.push(afterMatch);
      } else {
        parts.push(remainingText);
      }
    } else {
      parts.push(remainingText);
    }
  }
  
  return parts;
};

// Helper function to highlight parts of text marked with ** **
export const formatHighlights = (text) => {
  return formatProfileAndHighlights(text);
};

// Format text specifically for PDF
export const formatTextForPdf = (text) => {
  if (!text) return null;
  
  // Log per debug
  console.log("Formatting PDF text of length:", text.length);
  
  // Split the text into lines
  const lines = text.split('\n').filter(line => line.trim() !== '');
  
  // Initialize the formatted result
  const formattedResult = [];
  
  // Tracking state
  let sectionCount = 0;
  let isIntro = false;
  let sectionContent = [];
  let currentSectionTitle = null;
  
  // Process each line
  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    
    // Log per debugging - primi 50 caratteri di ogni linea
    console.log(`Line ${index}: ${trimmedLine.substring(0, 50)}${trimmedLine.length > 50 ? '...' : ''}`);
    
    // Salta la prima riga se è la classica intro
    if (index === 0 && trimmedLine.includes("Here is an analysis of the Instagram profile")) {
      return;
    }
    
    // Main titles (## headings)
    if (trimmedLine.startsWith('## ')) {
      // Se abbiamo una sezione precedente, la aggiungiamo al risultato
      if (currentSectionTitle && sectionContent.length > 0) {
        // Add divider except for first section
        if (sectionCount > 1) {
          formattedResult.push(
            <div 
              key={`pdf-divider-${sectionCount}`}
              className="section-divider"
              style={{
                margin: '30px auto',
                width: '70%',
                height: '2px',
                background: 'linear-gradient(to right, transparent, var(--secondary-color), transparent)',
                opacity: 0.6,
                position: 'relative',
                borderRadius: '2px',
                display: 'block'
              }}
            />
          );
        }
        
        // Add section title
        formattedResult.push(
          <h2 
            key={`pdf-title-${sectionCount}`} 
            className="pdf-section-title"
            style={{
              display: 'block',
              color: '#FFD000',
              fontSize: '22px',
              fontWeight: 600,
              margin: '25px 0 15px',
              textAlign: 'center',
              fontFamily: '"Bubblegum Sans", "Poppins", sans-serif',
              borderBottom: '1px solid rgba(255, 208, 0, 0.3)',
              paddingBottom: '10px'
            }}
          >
            {currentSectionTitle}
          </h2>
        );
        
        // Add content block containing the section content
        formattedResult.push(
          <div 
            key={`pdf-content-block-${sectionCount}`}
            className="pdf-content-block"
            style={{
              display: 'block',
              width: '100%',
              background: 'linear-gradient(145deg, rgba(26, 11, 51, 0.6), rgba(31, 15, 60, 0.8))',
              borderRadius: '12px',
              padding: '20px 25px',
              margin: '25px 0',
              position: 'relative',
              borderLeft: '2px solid #FF40C0'
            }}
          >
            {sectionContent}
          </div>
        );
        
        // Reset section content
        sectionContent = [];
      }
      
      sectionCount++;
      currentSectionTitle = trimmedLine.replace(/^## /, '').replace(/:$/, '');
      isIntro = true; // Il prossimo paragrafo sarà introduttivo
    } 
    // Subtitles (### headings)
    else if (trimmedLine.startsWith('### ')) {
      const titleText = trimmedLine.replace(/^### /, '').replace(/:$/, '');
      sectionContent.push(
        <h3 
          key={`pdf-subtitle-${index}`} 
          className="pdf-subsection-title"
          style={{
            display: 'block',
            color: '#FF40C0',
            fontSize: '18px',
            fontWeight: 600,
            margin: '16px 0 8px',
            paddingLeft: '12px',
            position: 'relative'
          }}
        >
          {titleText}
        </h3>
      );
    }
    // List items
    else if (trimmedLine.startsWith('* ') || trimmedLine.startsWith('- ')) {
      const itemText = trimmedLine.substring(2);
      // Formatter for list items with special handling
      const formattedText = formatPdfText(itemText);
      
      sectionContent.push(
        <div 
          key={`pdf-list-${index}`} 
          className="pdf-list-item"
          style={{
            display: 'block',
            width: '100%',
            marginBottom: '22px',
            paddingLeft: '28px',
            textAlign: 'justify',
            position: 'relative',
            lineHeight: '1.6'
          }}
        >
          <span 
            className="pdf-list-bullet"
            style={{
              position: 'absolute',
              left: '0',
              top: '2px',
              fontSize: '1rem',
              color: '#FF40C0'
            }}
          >•</span>
          <div dangerouslySetInnerHTML={{ __html: formattedText }} />
        </div>
      );
    }
    // Regular paragraphs
    else {
      // Format paragraph text with special handling
      const formattedText = formatPdfText(trimmedLine);
      
      // Check if this is an intro paragraph
      if (isIntro && !trimmedLine.startsWith('**') && trimmedLine.length > 50) {
        sectionContent.push(
          <div 
            key={`pdf-intro-${index}`} 
            className="pdf-intro-text"
            style={{
              display: 'block',
              width: '100%',
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '35px',
              color: 'rgba(255, 255, 255, 0.9)',
              fontSize: '16px',
              padding: '25px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, rgba(255, 64, 192, 0.2), rgba(255, 208, 0, 0.15))',
              position: 'relative'
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: formattedText }} />
          </div>
        );
        isIntro = false; // Reset flag
      } else {
        sectionContent.push(
          <div 
            key={`pdf-text-${index}`} 
            className="pdf-text"
            style={{
              display: 'block',
              width: '100%',
              marginBottom: '20px',
              textAlign: 'justify',
              lineHeight: '1.8'
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: formattedText }} />
          </div>
        );
      }
    }
  });
  
  // Aggiungiamo l'ultima sezione se presente
  if (currentSectionTitle && sectionContent.length > 0) {
    // Add divider except for first section
    if (sectionCount > 1) {
      formattedResult.push(
        <div 
          key={`pdf-divider-${sectionCount}`}
          className="section-divider"
          style={{
            margin: '30px auto',
            width: '70%',
            height: '2px',
            background: 'linear-gradient(to right, transparent, var(--secondary-color), transparent)',
            opacity: 0.6,
            position: 'relative',
            borderRadius: '2px',
            display: 'block'
          }}
        />
      );
    }
    
    // Add section title
    formattedResult.push(
      <h2 
        key={`pdf-title-${sectionCount}`} 
        className="pdf-section-title"
        style={{
          display: 'block',
          color: '#FFD000',
          fontSize: '22px',
          fontWeight: 600,
          margin: '25px 0 15px',
          textAlign: 'center',
          fontFamily: '"Bubblegum Sans", "Poppins", sans-serif',
          borderBottom: '1px solid rgba(255, 208, 0, 0.3)',
          paddingBottom: '10px'
        }}
      >
        {currentSectionTitle}
      </h2>
    );
    
    // Add content block containing the section content
    formattedResult.push(
      <div 
        key={`pdf-content-block-${sectionCount}`}
        className="pdf-content-block"
        style={{
          display: 'block',
          width: '100%',
          background: 'linear-gradient(145deg, rgba(26, 11, 51, 0.6), rgba(31, 15, 60, 0.8))',
          borderRadius: '12px',
          padding: '20px 25px',
          margin: '25px 0',
          position: 'relative',
          borderLeft: '2px solid #FF40C0'
        }}
      >
        {sectionContent}
      </div>
    );
  }
  
  // Log per debug
  console.log("PDF formatted sections:", formattedResult.length);
  
  return formattedResult;
};

// Funzione per formattare testo nel PDF con highlight speciali
const formatPdfText = (text) => {
  if (!text) return "";
  
  // Evidenzia i nomi/username con colore accent
  text = text.replace(/(named\s+)([\w\s]+(Nanta|nanta))/g, '$1<span style="color:#00D5FF;font-weight:600;position:relative;display:inline-block;">$2</span>');
  text = text.replace(/(known\s+as\s+)(["']?\@?[\w\._]+(gizzde|Supichaya|supichaya))/gi, '$1<span style="color:#00D5FF;font-weight:600;position:relative;display:inline-block;">$2</span>');
  text = text.replace(/(\@?[\w\._]+(gizzde|Supichaya|supichaya))/gi, '<span style="color:#00D5FF;font-weight:600;position:relative;display:inline-block;">$1</span>');
  
  // Poi sostituisci gli asterischi doppi con gli span evidenziati
  text = text.replace(/\*\*(.*?)\*\*/g, '<span style="color:#FFD000;font-weight:600;position:relative;display:inline-block;">$1</span>');
  
  return text;
};

const AnalysisFormatter = ({ analysisText }) => {
  return (
    <FormattedResultsContainer>
      {formatAnalysisText(analysisText)}
    </FormattedResultsContainer>
  );
};

export default AnalysisFormatter; 